import api from "utils/api";

//클래스, 투어 주문 생성
export const createOrder = async (params) => {
    try {
        const res = await api.post(
            `/buccl_main/api/v1/innopay/create-order/`,
            params
        );
        return res.data;
    } catch (error) {
        const errData = error.response?.data;
        return {
            message: errData?.message || errData?.error || "주문 생성에 실패했습니다.",
            code: errData?.code,
        };
    }
};

/**
 * 일반 상품 주문 생성 + Innopay 결제
 * @param {Object} params - 주문 파라미터
 * @param {number} params.product_id - 상품 ID
 * @param {number} params.variant_id - 옵션 ID
 * @param {number} params.quantity - 수량
 * @param {string} params.shipping_info - 배송지 ID
 * @param {string} params.shipping_info.recipient_name - 이름
 * @param {string} params.shipping_info.recipient_phone - 전화번호
 * @param {string} params.shipping_info.address - 주소
 * @param {string} params.shipping_info.address_detail - 상세 주소
 * @param {string} params.shipping_info.postal_code - 우편번호
 * @param {string} params.shipping_info.shipping_memo - 메모
 * @param {Array<string|null>} [params.customer_inputs] - 사용자 입력 옵션 답변(질문 순서와 동일). 주문 시점에 {question, answer}로 스냅샷된다.
 * @returns {Object} - 주문 정보
 * @returns {number} res.data.order_id - 주문 ID
 * @returns {string} res.data.product_name - 상품명
 * @returns {number} res.data.payment_params - Innopay 결제 파라미터 (프론트에서 결제창 띄우는 데 사용)
 */
export const createProductOrder = async (params) => {
    try {
        const res = await api.post(
            `/buccl_main/api/v1/products/orders/create/`,
            params
        );
        return res.data;
    } catch (error) {
        const errData = error.response?.data;
        return {
            message: errData?.message || errData?.error || "주문 생성에 실패했습니다.",
            code: errData?.code,
        };
    }
};

export const proceedPayment = async (params) => {
    try {
        /**
         * {
    "order_id": 5,                        # 주문ID
    "buyer_info": {                       # 
        "name": "테스트 유저",               # 구매자 이름
        "email": "test@example.com",      # 구매자 이메일
        "tel": "01012345678"              # 구매자 전화번
    }
}
         */

        const res = await api.post(
            `/buccl_main/api/v1/payment/auth/request/`,
            params
        );
        return res.data;
    } catch (error) {}
};
